import { useEffect } from 'react';
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
  useShadowRootElements,
} from '@backstage/plugin-techdocs-react';
import { techdocsExtensionPlugin } from '../../plugin';

const RemoveFeedbackLinkAddon = () => {
  const [feedbackLink] = useShadowRootElements(['#git-feedback-link']);
  useEffect(() => feedbackLink?.remove());
  return null;
};

export const RemoveFeedbackLink = techdocsExtensionPlugin.provide(
  createTechDocsAddonExtension({
    name: 'RemoveFeedbackLink',
    location: TechDocsAddonLocations.Content,
    component: RemoveFeedbackLinkAddon,
  }),
);
